import { motion } from "framer-motion";

export const Explosion = () => {
  // Sparkle particles - small bright dots
  const sparkles = Array.from({ length: 40 }, (_, i) => ({
    id: i,
    angle: (i / 40) * 360 + Math.random() * 20,
    distance: 80 + Math.random() * 180,
    size: 3 + Math.random() * 6,
    duration: 0.6 + Math.random() * 0.4,
    delay: Math.random() * 0.1,
  }));

  // Larger glowing orbs
  const orbs = Array.from({ length: 12 }, (_, i) => ({
    id: i,
    angle: (i / 12) * 360,
    distance: 60 + Math.random() * 100,
    size: 15 + Math.random() * 25,
    duration: 0.7 + Math.random() * 0.3,
  }));

  // Ring particles
  const rings = Array.from({ length: 3 }, (_, i) => ({
    id: i,
    delay: i * 0.15,
    scale: 8 + i * 4,
  }));

  return (
    <div className="absolute inset-0 flex items-center justify-center overflow-visible">
      {/* Initial bright flash */}
      <motion.div
        className="absolute w-64 h-64 rounded-full"
        style={{
          background:
            "radial-gradient(circle, rgba(255,255,255,0.9) 0%, hsl(280, 100%, 70%) 20%, hsl(260, 100%, 50%) 40%, transparent 70%)",
        }}
        initial={{ scale: 0, opacity: 1 }}
        animate={{ scale: 4, opacity: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      />

      {/* Central core glow */}
      <motion.div
        className="absolute w-32 h-32 rounded-full"
        style={{
          background:
            "radial-gradient(circle, rgba(255,255,255,1) 0%, hsl(280, 100%, 80%) 30%, hsl(260, 80%, 60%) 60%, transparent 100%)",
          boxShadow:
            "0 0 80px hsl(280, 100%, 70%), 0 0 160px hsl(260, 100%, 50%), 0 0 240px hsl(240, 80%, 40%)",
        }}
        initial={{ scale: 0, opacity: 1 }}
        animate={{ scale: [0, 1.5, 2], opacity: [1, 0.8, 0] }}
        transition={{ duration: 0.7, ease: "easeOut" }}
      />

      {/* Expanding rings */}
      {rings.map((ring) => (
        <motion.div
          key={`ring-${ring.id}`}
          className="absolute w-16 h-16 rounded-full"
          style={{
            border: "3px solid",
            borderColor: "hsl(280, 100%, 70%)",
            boxShadow:
              "0 0 20px hsl(280, 100%, 60%), inset 0 0 20px hsl(280, 100%, 60%)",
          }}
          initial={{ scale: 0, opacity: 0.8 }}
          animate={{ scale: ring.scale, opacity: 0 }}
          transition={{
            duration: 0.8,
            delay: ring.delay,
            ease: "easeOut",
          }}
        />
      ))}

      {/* Glowing orbs */}
      {orbs.map((orb) => (
        <motion.div
          key={`orb-${orb.id}`}
          className="absolute rounded-full"
          style={{
            width: orb.size,
            height: orb.size,
            background: `radial-gradient(circle, rgba(255,255,255,0.9) 0%, hsl(280, 100%, 70%) 40%, hsl(260, 80%, 50%) 80%, transparent 100%)`,
            boxShadow:
              "0 0 20px hsl(280, 100%, 60%), 0 0 40px hsl(260, 80%, 50%)",
          }}
          initial={{
            x: 0,
            y: 0,
            opacity: 1,
            scale: 1,
          }}
          animate={{
            x: Math.cos((orb.angle * Math.PI) / 180) * orb.distance,
            y: Math.sin((orb.angle * Math.PI) / 180) * orb.distance,
            opacity: 0,
            scale: 0.3,
          }}
          transition={{
            duration: orb.duration,
            ease: "easeOut",
          }}
        />
      ))}

      {/* Sparkle particles */}
      {sparkles.map((sparkle) => (
        <motion.div
          key={`sparkle-${sparkle.id}`}
          className="absolute rounded-full"
          style={{
            width: sparkle.size,
            height: sparkle.size,
            background: "white",
            boxShadow: "0 0 8px white, 0 0 16px hsl(280, 100%, 70%)",
          }}
          initial={{
            x: 0,
            y: 0,
            opacity: 1,
            scale: 1,
          }}
          animate={{
            x: Math.cos((sparkle.angle * Math.PI) / 180) * sparkle.distance,
            y: Math.sin((sparkle.angle * Math.PI) / 180) * sparkle.distance,
            opacity: 0,
            scale: 0,
          }}
          transition={{
            duration: sparkle.duration,
            delay: sparkle.delay,
            ease: "easeOut",
          }}
        />
      ))}

      {/* Central star burst */}
      <motion.div
        className="absolute text-7xl"
        initial={{ scale: 0, opacity: 1, rotate: 0 }}
        animate={{
          scale: [0, 1.2, 1],
          opacity: [1, 1, 0],
          rotate: [0, 90],
        }}
        transition={{ duration: 1, ease: "easeOut" }}
        style={{
          filter:
            "drop-shadow(0 0 20px hsl(280, 100%, 70%)) drop-shadow(0 0 40px hsl(260, 80%, 60%))",
        }}
      >
        {/* ✨ */}
        <img src="/hadesz.svg" alt="✨" />
      </motion.div>
    </div>
  );
};
